import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/assignment';
import * as assignmentPageActions from '../actions/assignment'
import * as enrollmentPageActions from '../actions/enrollment';
import { SecurityContextType, MessageState } from '../../models/components/announcement.d';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import { AssigmentService } from '../../api/assigment-services';
import * as coreActions from '../actions/core';
import { Notification } from '../../components/notification/main';
import { IAssignmentStudentList } from '../../models/action/assignment';

import Translator from '../../core/i18n';
import { ActivityCompletionType } from '../../models/enums/activityCompletionType';
const T = Translator.create();
const _logger = Log.create('assignment_sagas');
const _assigmentService = new AssigmentService();

//#region "Add Assignment Activity Saga"
function* setAddAssignmentActivity(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        yield put(assignmentPageActions.addAssignmentSetAction(null));
        const pageData = yield _assigmentService.RequestAddAssigmentActivityAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });

        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
            if (params.callback) {
                params.callback(null);
            }
        }

        if (!isError) {
            yield put(
                coreActions.newNotification(
                    params.AssignmentData.activityId
                        ? T.t('r_update_activity_succesful_notification')
                        : T.t('r_add_activity_succesful_notification'),
                    '',
                    '',
                    'topRight',
                    'success'
                )
            );
            const redirectPageParams: any = {
                submitValues: params.AssignmentData,
                activityId: params.AssignmentData.projectActivityId ? params.AssignmentData.projectActivityId : params.AssignmentData.activityId ? params.AssignmentData.activityId : pageData,
                termWeekId:
                    params.AssignmentData.termWeekIds && params.AssignmentData.termWeekIds[0] !== '0'
                        ? params.AssignmentData.termWeekIds[0]
                        : params.AssignmentData.termWeekIds[1]
            };
            yield put(assignmentPageActions.addAssignmentSetAction(null));
            params.callback(redirectPageParams);
        }
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        if (params.callback) {
            params.callback(null);
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

// update Add assigenemnt data!!!
function* setAssignementActivity(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        yield put(assignmentPageActions.addAssignmentSetAction(null));
        const pageData = yield _assigmentService.RequestGetAssignmentAsync({ ...params, take: 20, skip: 0 })
            .then((response: Response) => {
                return response;
            })
            .then((response: Response) => {
                if (response.status !== 200) {
                    isError = true;
                }
                return response.json();
            })
            .then((responseData: any) => {
                if (isError) {
                    errorList = responseData;
                } else {
                    return responseData;
                }
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_api_gen_update_activity_error'), 'topRight');

            return false;
        } else {
            yield put(assignmentPageActions.addAssignmentSetAction(pageData, params.spinnerId, 'set'));
            return true;
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_api_gen_update_activity_error'), 'topRight');
        return false;
    }
}

function* setDeleteAssignmentActivity(params: any): any {
    try {

        // yield put(coursePageActions.setCoursePageHeaderInformationData(nullData, [], false));
        const pageData = yield _assigmentService.RequestDeleteAssigmentActivityAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((data: any | null) => {
            if (data === undefined || data === false) {
                return null;
            } else {
                return data;
            }
        });

        yield put(assignmentPageActions.addAssignmentSetAction(null));
        // tslint:disable-next-line: no-empty
    } catch (error: any) {

    }
}

function* setSendAssignment(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield _assigmentService.RequestSendAssignmentAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            }
        });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                })
                : Notification.setNotification('error', T.t('r_api_send_assigment_failed'), 'topRight');
        }

        if (!isError) {
            yield put(assignmentPageActions.updateUploadCount(params.UploadCount, params.AssignmentData.EnrollmentId));
            yield put(enrollmentPageActions.enrollmentAddActionLog(
                {
                    ActivityCompletionType: ActivityCompletionType.Upload,
                    ClassId: params.AssignmentData.ClassId,
                    EnrollmentId: params.AssignmentData.EnrollmentId ?? '',
                    ActivityId: params.AssignmentData.ActivityId
                }));
            yield put(coreActions.newNotification(T.t('r_api_send_assignment_success'), '', '', 'topRight', 'success'));
            params.callback(true);
        }
    } catch (error: any) {
        return null;
    }
}

function* getAssignmentStudentLists(params: IAssignmentStudentList) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _assigmentService.RequestGetAssignmentStudentListsAsync({ ...params.filters, ...params.paging })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
        yield _yield;

        if (!isError) {
            yield put(assignmentPageActions.SetAssignmentStudentList(pageData.users, pageData.filters, params.spinnerId ? params.spinnerId : '', 'set'));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getMyAssignments(params: any): any {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _assigmentService.RequestGetMyAssignmentsAsync(params.Filters).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_assignment_page_my_error_message'), 'topRight');
        }
        if (!isError) {
            yield put(assignmentPageActions.getMyAssignmentsSetAction(pageData, params.spinnerId, 'set'));
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_assignment_page_my_error_message'), 'topRight');
    }
}

export function* watchGetAddAssignmentData() {
    yield takeEvery(constants.actions.ADD_ASSIGMENT_ACTIVITY, setAddAssignmentActivity);
    return null;
}

export function* watchGetDeleteAssignmentData() {
    yield takeEvery(constants.actions.DELETE_ASSIGNMENT_ACTIVITY, setDeleteAssignmentActivity);
    return null;
}

export function* watchAddAssignementGetData() {
    yield takeEvery(constants.actions.UPDATE_ASSIGNMENT_ACTIVITY, setAssignementActivity);
    return null;
}

export function* watchSendAssignment() {
    yield takeEvery(constants.actions.SEND_ASSIGNMENT_GET, setSendAssignment);
    return null;
}

export function* watchGetAssignmentStudentLists() {
    yield takeEvery(constants.actions.GET_ASSIGNMENT_STUDENT_LIST, getAssignmentStudentLists);
    return null;
}

export function* watchGetMyAssigments() {
    yield takeEvery(constants.actions.GET_MY_ASSIGNMENTS, getMyAssignments);
}

//#endregion "Add Assignment Activity End Saga"

export function* AssignmentSagas() {
    yield all([
        watchGetAddAssignmentData(),
        watchGetDeleteAssignmentData(),
        watchAddAssignementGetData(),
        watchSendAssignment(),
        watchGetAssignmentStudentLists(),
        watchGetMyAssigments()
    ]);
}
